import { Radio } from "antd";
import LabelAndValue from "../../form/LabelAndValue";

const HRadioGroup = (props) => {
  const { options, groupLabel, radioGroupProps = {}, radioProps, value, onChange } = props;
  return (
    <LabelAndValue label={groupLabel}>
      <Radio.Group {...radioGroupProps} value={value ?? radioGroupProps.value} onChange={onChange ?? radioGroupProps.onChange}>
        {options?.map((option) => {
          return (
            <>
              {option?.tag ? (
                <div key={option?.value || ""}>
                  <HRadio radioProps={radioProps} option={option} data-cy={option?.dataCy} />
                  {option?.tag && <div className="hs-fs-12 hs-color-dark-grey ms-4 mt-1">{option.tag}</div>}
                </div>
              ) : (
                <HRadio radioProps={radioProps} option={option} data-cy={option?.dataCy} />
              )}
            </>
          );
        })}
      </Radio.Group>
    </LabelAndValue>
  );
};
const HRadio = ({ radioProps, option }) => (
  <Radio {...radioProps} className="hs-radio-btn" key={option?.value} value={option?.value} data-cy={option?.dataCy}>
    {option?.label || option?.value}
  </Radio>
);
export default HRadioGroup;
